import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import * as S from '../landing.style';
import OtherService from '../OtherService';
import { PageContainer } from '../../components/common/PageComponent.style';
import PageTop from '../../components/pageTop/PageTop';
import Footer from '../../components/footer/Footer';

function MapSearchGuide() {
  const navigate = useNavigate();

  return (
    <LocalStyleWrapper>
      <PageContainer>
        <S.Container>
          <PageTop text="지도 검색" hasSearch={false} />

          <HeroSection>
            <S.HeroTitleWrapper>
              <S.BadgeContainer>
                <S.MembershipBadgeFree>
                  <span>무료</span>
                </S.MembershipBadgeFree>
                <S.MembershipBadgeStandard>
                  <span>스탠다드</span>
                </S.MembershipBadgeStandard>
                <S.MembershipBadgePremium>
                  <span>프리미엄</span>
                </S.MembershipBadgePremium>
              </S.BadgeContainer>
              <HeroTitle>
                경매의 시작,
                <br />
                익숙한 지역에서 시작해보세요
              </HeroTitle>
            </S.HeroTitleWrapper>
            <HeroDescription>
              어떤 물건을 입찰해야 할 지 모르겠다면,
              <br />
              지도에서 내가 잘 알고있는 지역부터 둘러보세요.
            </HeroDescription>
          </HeroSection>

          <Section>
            <SectionContainer>
              <S.ColBox $gap={8} $center>
                <SampleText>지도 검색</SampleText>
                <SectionTitle>땅집고옥션의 지도검색</SectionTitle>
                <Sample>이렇게 이용해보세요</Sample>
              </S.ColBox>
            </SectionContainer>
          </Section>

          <IntroSection>
            <IntroSectionImgWrapper>
              <img src="/assets/images/guide-landing/map/map1.png" alt="" />
            </IntroSectionImgWrapper>
            <IntroSectionTextArea>
              <SectionTitle>지역 내 물건 종합 비교</SectionTitle>
              <SectionDescription>
                지도에서 원하는 지역의 경매, 공매, 실거래가, 예정 물건을 한 눈에
                비교하며 투자 결정을 내릴 수 있습니다.
              </SectionDescription>
            </IntroSectionTextArea>
          </IntroSection>

          <IntroSection>
            <IntroSectionImgWrapper>
              <img src="/assets/images/guide-landing/map/map2.png" alt="" />
            </IntroSectionImgWrapper>
            <IntroSectionTextArea>
              <SectionTitle>낙찰가 산정</SectionTitle>
              <SectionDescription>
                진행 중인 물건 뿐만 아니라 해당 지역의 과거 낙찰 사례,
                낙찰가율을 참고해 얼마에 입찰해야 낙찰받을 수 있을 지 유추할 수
                있습니다.
              </SectionDescription>
            </IntroSectionTextArea>
          </IntroSection>

          <IntroSection>
            <IntroSectionImgWrapper $noBg>
              <img src="/assets/images/guide-landing/map/map3.png" alt="" />
            </IntroSectionImgWrapper>
            <IntroSectionTextArea>
              <SectionTitle>가치판단</SectionTitle>
              <SectionDescription>
                공시지가와 실거래가를 비교해 현재 보고 있는 물건이
                고평가되었는지, 저평가되었는지 파악하고 합리적인 투자 결정을
                내릴 수 있습니다.
              </SectionDescription>
            </IntroSectionTextArea>
          </IntroSection>

          <ImgSection>
            <ResponsiveCtaTitle>
              내가 원하는 지역에서
              <br />
              최저가, 실거래가, 공시지가 모두
              {'\n'}
              비교해보세요
            </ResponsiveCtaTitle>
            <CtaButton onClick={() => navigate('/map')}>
              지도검색 바로가기
            </CtaButton>
          </ImgSection>

          <OtherService page="map" />

          <Footer />
        </S.Container>
      </PageContainer>
    </LocalStyleWrapper>
  );
}

export default MapSearchGuide;

const LocalStyleWrapper = styled.div`
  * {
    word-break: keep-all;
  }
`;

const HeroSection = styled.div`
  display: flex;
  padding: 40px 24px;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  background-image: url('/assets/images/guide-landing/map/hero_bg.png');
  background-size: cover;
  background-position: center;
`;

const HeroTitle = styled.div`
  color: #000;
  font-size: 24px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.56px;

  @media (min-width: 500px) {
    font-size: 32px;
  }
`;

const HeroDescription = styled.div`
  color: #222;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;

  @media (min-width: 500px) {
    font-size: 16px;
  }
`;

const Section = styled.div`
  display: flex;
  padding: 24px 16px 0px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

const SectionContainer = styled.div`
  flex-direction: row;
  justify-content: center;
`;

const SectionTitle = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: -2%;

  @media (min-width: 500px) {
    font-size: 20px;
  }
`;

const SectionDescription = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -2%;

  @media (min-width: 500px) {
    font-size: 15px;
  }
`;

const IntroSection = styled(S.Section)`
  padding: 40px 16px;
`;

const IntroSectionTextArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 328px;

  @media (min-width: 500px) {
    width: 420px;
  }
`;

const IntroSectionImgWrapper = styled.div<{ $noBg?: boolean }>`
  display: flex;
  padding: 24px 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  background: ${({ $noBg }) => ($noBg ? 'transparent' : '#cdf6e7')};
  height: 262.4px;
  overflow: hidden;

  & > img {
    width: 328px;
    height: 262.4px;
    object-fit: cover;
    position: relative;
    z-index: 1;
  }

  @media (min-width: 500px) {
    height: 320px;

    & > img {
      width: 420px;
      height: 320px;
    }
  }
`;

const CtaButton = styled(S.CtaButton)`
  color: #197751;
  margin-top: 30px;
  &:hover {
    background: #e7f0fe;
  }
  &:active {
    background: #c2e2ff;
  }
  @media (min-width: 500px) {
    margin: auto 0 auto 20px;
  }
`;

const SampleText = styled.div`
  color: #09bb73;
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;

  @media (min-width: 500px) {
    font-size: 15px;
  }
`;

const Sample = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;

  @media (min-width: 500px) {
    font-size: 15px;
  }
`;

const ResponsiveCtaTitle = styled(S.CtaTitle)`
  white-space: pre-line;

  @media (min-width: 500px) {
    white-space: normal;
  }
`;

const ImgSection = styled.div`
  gap: 10px;
  padding: 35px 20px;
  align-self: stretch;
  background:
    linear-gradient(rgba(24, 90, 64, 0.9), rgba(24, 90, 64, 0.9)),
    url(/assets/images/guide-landing/map/map_bg_pc.png) no-repeat center / cover;
  background-color: #197751;
  align-items: flex-start;

  @media (min-width: 500px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;
